/* eslint-disable @typescript-eslint/no-explicit-any */
import type Highcharts from "highcharts";

declare module "highcharts" {
  interface Chart {
    isDirtyBox: boolean;
  }

  interface Series {
    isDirtyData: boolean;
    isDirty: boolean;
  }

  interface Axis {
    isDirty: boolean;
  }
}

export default function fixNavigatorRedraw(H: typeof Highcharts) {
  H.wrap(
    H.Axis.prototype,
    "redraw",
    function (this: Highcharts.Axis, proceed: any, ...args: unknown[]) {
      if (this.options.id?.startsWith("navigator-") && !this.isDirty) return;

      return proceed.apply(this, args);
    },
  );

  H.wrap(
    H.Series.prototype,
    "redraw",
    function (this: Highcharts.Series, proceed: any, ...args: unknown[]) {
      const dirtyXAxis = this.xAxis.isDirty;
      const dirtyYAxis = this.yAxis.isDirty;
      const dirtyBox = this.chart.isDirtyBox;
      const dirty = this.isDirty;
      const dirtyData = this.isDirtyData;

      if (!dirtyXAxis && !dirtyYAxis && !dirtyBox && !dirty && !dirtyData) return;

      return proceed.apply(this, args);
    },
  );
}
